import React from "react";
import { Helmet } from "react-helmet-async";
import PropTypes from "prop-types";

const SEO = ({
  title,
  description = "TradingWhales is India's Professional Stock Market Training Institute offering Stock Market, Options Trading, Forex Trading, Technical Analysis, Price Action, Smart Money Concepts (SMC), ICT Concepts, Risk Management, Live Market Training, AI Trading Learning and Professional Trading Courses.",
  keywords = "Stock Market Training Institute, Stock Market Course, Trading Institute India, Trading Academy, Options Trading Course, Forex Trading Course, Technical Analysis, Price Action, Smart Money Concepts, ICT Trading, Intraday Trading, Swing Trading, Futures Trading, Nifty Trading, Bank Nifty Trading, TradingWhales",
  image = "https://tradingwhales.in/assets/images/meta-banner.jpg",
  url = "https://tradingwhales.in/",
}) => {
  const pageTitle = title
    ? `${title} | TradingWhales`
    : "TradingWhales | India's Professional Stock Market Training Institute";

  return (
    <Helmet>
      {/* Basic SEO */}
      <html lang="en" />
      <meta charSet="utf-8" />

      <title>{pageTitle}</title>

      <meta
        name="description"
        content={description}
      />

      <meta
        name="keywords"
        content={keywords}
      />

      {/* IMPORTANT: Allow Google to index */}
      <meta
        name="robots"
        content="index, follow, max-image-preview:large"
      />

      <meta
        name="viewport"
        content="width=device-width, initial-scale=1"
      />

      <meta
        name="author"
        content="TradingWhales"
      />

      <meta
        name="theme-color"
        content="#0B1020"
      />

      <link
        rel="canonical"
        href={url}
      />

      {/* Open Graph */}
      <meta
        property="og:type"
        content="website"
      />

      <meta
        property="og:site_name"
        content="TradingWhales"
      />

      <meta
        property="og:title"
        content={pageTitle}
      />

      <meta
        property="og:description"
        content={description}
      />

      <meta
        property="og:image"
        content={image}
      />

      <meta
        property="og:image:width"
        content="1200"
      />

      <meta
        property="og:image:height"
        content="630"
      />

      <meta
        property="og:url"
        content={url}
      />

      <meta
        property="og:locale"
        content="en_IN"
      />

      {/* Twitter */}
      <meta
        name="twitter:card"
        content="summary_large_image"
      />

      <meta
        name="twitter:title"
        content={pageTitle}
      />

      <meta
        name="twitter:description"
        content={description}
      />

      <meta
        name="twitter:image"
        content={image}
      />

      {/* Favicon */}
      <link
        rel="icon"
        href="/favicon.ico"
      />
    </Helmet>
  );
};

SEO.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  keywords: PropTypes.string,
  image: PropTypes.string,
  url: PropTypes.string,
};

export default SEO;
